import Quill, { Delta, Parchment } from 'quill/core';
import type { AttributeMap, Op } from 'quill/core';

const getIsInsertionBlockEmbed = (
  quill: Quill,
  insertion: NonNullable<Op['insert']>,
) => {
  if (typeof insertion === 'object') {
    const key = Object.keys(insertion)[0];
    return key && quill.scroll.query(key, Parchment.Scope.BLOCK) != null;
  }

  return false;
};

const replaceEmbedBlotWith = (
  quill: Quill,
  blot: Parchment.EmbedBlot,
  insert: NonNullable<Op['insert']>,
  attributes?: AttributeMap,
) => {
  const index = blot.offset(quill.scroll);

  let isTrailingNewlineLeft = false;
  let isBlotAtBeginningOfLine = true;
  const isBlotBlock =
    // eslint-disable-next-line no-bitwise
    blot.statics.scope & Parchment.Scope.LEVEL & Parchment.Scope.BLOCK;
  if (!isBlotBlock) {
    const [line, lineOffset] = quill.getLine(index);
    if (!line) return;
    isTrailingNewlineLeft = lineOffset + 1 === line.length() - 1;
    isBlotAtBeginningOfLine = lineOffset === 0;
  }

  quill.history.cutoff();

  let insertedAt = index;
  const delta = new Delta().retain(index).delete(1);

  const isInsertionBlockEmbed = getIsInsertionBlockEmbed(quill, insert);
  if (!isBlotAtBeginningOfLine && isInsertionBlockEmbed) {
    delta.insert('\n');
    insertedAt += 1;
  }

  delta.insert(insert, attributes);

  if (isBlotBlock && !isInsertionBlockEmbed) {
    delta.insert('\n');
  } else if (isTrailingNewlineLeft && isInsertionBlockEmbed) {
    delta.delete(1);
  }

  quill.updateContents(delta, Quill.sources.USER);

  // @ts-expect-error
  quill.focusWithoutScrolling();
  quill.setSelection(
    insertedAt,
    typeof insert === 'string' ? insert.length : 1,
    Quill.sources.USER,
  );
};

export default replaceEmbedBlotWith;
